import * as React from 'react';
import AppLayoutContextUpdater from '../../Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import NotificationDisplay from '../NotificationDisplay/NotificationDisplay';
import { WindowWrapper } from 'login-utils/globalWrappers';
import * as _ from 'lodash';

class ResentActivation extends React.Component<{}, {}> {
  render() {
    const orgConfig = WindowWrapper.DEPLOYMENT_CONFIG.organization;

    const resentMsg = `Your account has not been activated. Please check your email for your activation link. You can also contact ${
      orgConfig.name
    } for further assistance.`;
    const appContextTitle = 'Activation link re-sent';
    const appDocumentTitle = 'Resent Activation Link';
    // TODO: this is also being used in ActivationExpired, consider moving getSupportEmail function to utils.
    const supportEmail = _.find(
      orgConfig.notificationDetails,
      notificationDetail => notificationDetail.senderEmailIdType === 'SUPPORT',
    );
    const supportEmailAddress = supportEmail ? supportEmail.senderEmailId : '';

    return (
      <div className="ResentActivation">
        <AppLayoutContextUpdater appTitle={appContextTitle} footerConfig={null} appDocumentTitle={appDocumentTitle}>
          {!!supportEmailAddress && (
            <NotificationDisplay
              message={resentMsg}
              emailSubject="Resent activation link"
              supportEmail={supportEmailAddress}
              orgName={orgConfig.name}
            />
          )}
        </AppLayoutContextUpdater>
      </div>
    );
  }
}

export default ResentActivation;
